import { useCallback, useState } from 'react';
import {
  ReactFlow,
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  Background
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import OrchestratorUpdaterNode from './ParallelOrchestrator';
import SerialOrchestrator from './SerialOrchestrator';
import IndividualAgent from './IndividualAgent';
import IndividualTool from './IndividualTool';
import OrchestratorHeader from './header/OrchestratorHeader';

const initialNodes = [
    {
        id: 'node-1',
        type: 'textUpdater',
        position: { x: 0, y: 0 },
        data: { value: 123 },
      },
      {
        id: 'node-2',
        type: 'serialOrchestrator',
        position: { x: 200, y: 0 },
        data: { value: 456 },
      },
      {
        id: 'node-3',
        type: 'individualAgent',
        position: { x: 400, y: 0 },
        data: { value: 789 },
      },
      {
        id: 'node-4',
        type: 'individualTool',
        position: { x: 500, y: 0 },
        data: { value: 789 },
      },
];

// we define the nodeTypes outside of the component to prevent re-renderings
// you could also use useMemo inside the component
const nodeTypes = { textUpdater: OrchestratorUpdaterNode ,
    serialOrchestrator: SerialOrchestrator,
    individualAgent: IndividualAgent,
    individualTool: IndividualTool
};

export default function AddOrchestrator() {
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState<any[]>([]); // Explicitly define the type

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes]
  );

  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges]
  );

  const onConnect = useCallback(
    (connection) => setEdges((eds) => addEdge(connection, eds)),
    [setEdges]
  );

  return (
    <div className='w-full h-screen'>
        <OrchestratorHeader />
        <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        fitView
        style={{backgroundColor: 'rgb(250 250 250)'}}
        >
            <Background />
        </ReactFlow>
    </div>
  );
}
